var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-page',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('registration-header')]},proxy:true},{key:"footer",fn:function(){return [_c('k-footer')]},proxy:true}])},[_c('k-container',[_c('rejection-description')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }